import { StreetSweepingSchedule } from "../models";

export const formattedStreetAddress = (
  streetObject: StreetSweepingSchedule
) => {
  const { streetName, suburb, postcode } = streetObject;
  return `${streetName}, ${suburb} ${postcode}`;
};

export const getLastItem = (objArray: ReadonlyArray<any>) => {
  return objArray.length > 0 ? objArray[objArray.length - 1] : null;
};

export const convertEpochToDisplayDate = (epochDateStr: string): string => {
  const dateObject = new Date(parseInt(epochDateStr));
  return dateObject.toLocaleDateString("en-AU", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
